var app = angular.module('directives.common', []);

require('./directive.js');
require('./service.js');
require('./keyboard-nav.js');

module.exports = 'directives.common';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/common/index.js
 ** module id = 29
 ** module chunks = 1
 **/